import React from "react";
import { Link } from "react-router-dom";

const SessaoEncerrada: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#0d343d",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          background: "#fff",
          borderRadius: 12,
          padding: "32px 24px",
          boxSizing: "border-box",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <h1
          style={{
            fontSize: 26,
            marginBottom: 12,
            fontWeight: 600,
            color: "#000",
          }}
        >
          Sessão encerrada
        </h1>

        <p
          style={{
            fontSize: 15,
            marginBottom: 16,
            color: "#333",
            lineHeight: 1.4,
          }}
        >
          Seu acesso foi desconectado porque a mesma conta foi utilizada em
          outro computador.
        </p>

        <p
          style={{
            fontSize: 14,
            marginBottom: 24,
            color: "#555",
            lineHeight: 1.5,
          }}
        >
          Se você reconhece esse acesso, basta entrar novamente. Caso não
          reconheça, recomendamos alterar sua senha.
        </p>

        <div style={{ display: "flex", gap: 12 }}>
          <Link
            to="/entrar"
            style={{
              flex: 1,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 18px",
              borderRadius: 8,
              border: "none",
              background: "#0d343d",
              color: "#fff",
              fontWeight: 500,
              fontSize: 15,
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Fazer login novamente
          </Link>

          <Link
            to="/redefinir-senha"
            style={{
              flex: 1,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 18px",
              borderRadius: 8,
              border: "1px solid #0d343d",
              background: "#fff",
              color: "#0d343d",
              fontWeight: 500,
              fontSize: 14,
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Alterar senha
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SessaoEncerrada;
